import React, { useState, useEffect } from "react";

function Loader() {
    return (
        <>
            <span class="loader"></span>
        </>
    );
}
export default Loader;



